export { default as NextPureTooltipIconLinkHelper } from './NextPureTooltipIconLinkHelper';
